import { render, staticRenderFns } from "./supervisorRightPie.vue?vue&type=template&id=5cd8ac33"
import script from "./supervisorRightPie.vue?vue&type=script&lang=js"
export * from "./supervisorRightPie.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports